import styles from "./styles.module.css";

export interface MilestoneRailItem {
  id: string;
  label: string;
  title: string;
  body: string;
}

interface MilestoneRailProps {
  items: MilestoneRailItem[];
}

export function MilestoneRail({ items }: MilestoneRailProps) {
  return (
    <ol className={styles.rail} data-reveal>
      {items.map((item, index) => (
        <li key={item.id} className={styles.item} data-reveal>
          <span className={styles.index}>{String(index + 1).padStart(2, "0")}</span>
          <span className={styles.label}>{item.label}</span>
          <h3 className={styles.title}>{item.title}</h3>
          <p className={styles.body}>{item.body}</p>
        </li>
      ))}
    </ol>
  );
}

export default MilestoneRail;
